import { createAction } from "@ngrx/store";

export const startBusy = createAction("[Busy Component] Start Busy");

export const finishBusy = createAction("[Busy Component] Finish Busy");
